// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const fermentationParameterProfileArchiveId = (z.number());
export const fermentationParameterProfileArchive = z.object({
    id: fermentationParameterProfileArchiveId,
    fermentation_id: z.number().nullable(),
    parameter_type_id: z.number().nullable(),
    line_type_id: z.number().nullable(),
    effective_at: z.date().nullable(),
    number_value: z.string().nullable(),
    source_type: z.string().nullable(),
    protocol_application_id: z.number().nullable(),
    deleted_at: z.date().nullable(),
    points: z.unknown().nullable(),
});
export const fermentationParameterProfileArchiveInitializer = z.object({
    id: fermentationParameterProfileArchiveId,
    fermentation_id: z.number().optional().nullable(),
    parameter_type_id: z.number().optional().nullable(),
    line_type_id: z.number().optional().nullable(),
    effective_at: z.date().optional().nullable(),
    number_value: z.string().optional().nullable(),
    source_type: z.string().optional().nullable(),
    protocol_application_id: z.number().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    points: z.unknown().optional().nullable(),
});
export const fermentationParameterProfileArchiveMutator = z.object({
    id: fermentationParameterProfileArchiveId.optional(),
    fermentation_id: z.number().optional().nullable(),
    parameter_type_id: z.number().optional().nullable(),
    line_type_id: z.number().optional().nullable(),
    effective_at: z.date().optional().nullable(),
    number_value: z.string().optional().nullable(),
    source_type: z.string().optional().nullable(),
    protocol_application_id: z.number().optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    points: z.unknown().optional().nullable(),
});
//# sourceMappingURL=FermentationParameterProfileArchive.js.map